import "./Tabs.scss";

import { Tab, Tabs as AppKitTabs } from "@appkit4/react-components/tabs";
import type { ReactNode } from "react";

export interface TabsItem {
  key: string;
  label: ReactNode;
  content: ReactNode;
}

export interface TabsProps {
  items: TabsItem[];
  className?: string;
  activeIndex?: number;
  defaultActiveIndex?: number;
  variant?: "underline" | "filled";
  /** Fired with the tab's `key` (not the raw AppKit index) whenever the active tab changes. */
  onTabChange?: (key: string) => void;
}

export function Tabs({
  items,
  className = "",
  activeIndex,
  defaultActiveIndex = 0,
  variant = "underline",
  onTabChange,
}: TabsProps) {
  const classes = ["shared-tabs", `shared-tabs--${variant}`, className].filter(Boolean).join(" ");

  return (
    <AppKitTabs
      className={classes}
      type={variant}
      activeIndex={activeIndex}
      defaultActiveIndex={defaultActiveIndex}
      onTabChange={(index) => {
        const item = items[index];
        if (item != null) {
          onTabChange?.(item.key);
        }
      }}
    >
      {items.map((item) => (
        <Tab key={item.key} label={item.label}>
          {item.content}
        </Tab>
      ))}
    </AppKitTabs>
  );
}
